<template>
  <div class="input-block" :class="{[formParam]:true,}">
    <form-input
      name="last_name"
      type="text"
      v-model="last_name"
      label="姓"
      placeholder="山田"
      :validation="{ rules: {max: 5, required: true} }"
    ></form-input>
    <form-input
      name="first_name"
      type="text"
      v-model="first_name"
      label="名"
      placeholder="はな"
      :validation="{ rules: {max: 5, required: true} }"
    />
  </div>
</template>

<script>
export default {
  name: 'InputBlockFullname',
  data(){
    return {
      last_name: '',
      first_name: '',
      buttonIsDisabled: false,
    }
  },
  props: {
    dataSet: {
      type: Array,
      default: [],
    },
    formParam: {
      type: String,
      default: '',
    }
  },
  computed: {
    validateFlags () {
      return this.$validator.flags
    },
  },
  watch:{
    dataSet: {
      handler(val) {
        if (val.length > 0) {
          const inputs = this.$el.querySelectorAll('input')
          inputs.forEach(item => {
            item.value = ''
          })

          /*
          val.forEach(item => {
            console.log('item[%O]', item)
            if (item.key === 'last_name' || item.key === 'first_name') {
              this[item.key] = item.value
            }
          })
           */
        }
      },
      deep: true,
    },
    validateFlags: {
      handler(n) {
        this.buttonIsDisabled = Object.keys(n).some((key)=> n[key].invalid)
        this.$emit('on-input', {
          key: this.formParam,
          disable: this.buttonIsDisabled,
          inputData: {
            last_name: this.last_name,
            first_name: this.first_name,
          }
        })
      },
      deep: true
    },
  },
}</script>

<style scoped lang="scss">
.input-block {
  &.fullname {
    display: flex;
    justify-content: space-between;
    .form-input {
      width: 48%;
    }
  }

}


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/inputParts/InputBlockFullname.vue